/**
 * @Author: WangZhuang@baidu.com
 * @Date: 2023-01-10 17:48:53
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2023-09-06 16:18:07
 * @FilePath: /m-anquan-baidu-com/src/App.js
 * @Description: App
 */

import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import Home from './containers/home';
import Forum from './containers/forum';
import Mark from './containers/mark';
import Page from './containers/page';
import Search from './containers/search';
import NavBar from './components/NavBar';
import FooterBar from './components/FooterBar';
import Product from './containers/product';
import Apply from './containers/apply';
import ApplyPlan from './containers/apply_plan';
import AppliSucc from './containers/appliSucc';
import Help from './containers/help';
import Community from './containers/community';
import About from './containers/about';
import Redirect404 from './containers/redirect';
import Brand from './containers/brand';
import Submission from './containers/submission';
import ProductCenter from './containers/productCenter';
import ProductDetail from './containers/productDetails';
import NumberSearch from './containers/numberSearch';
import NumberSearchResult from './containers/numberSearch/searchResult';
import NumberCommon from './containers/numberCommon';
import NumberGuide from './containers/numberOptions/guidePage';
import NumberReport from './containers/numberOptions/numberReport';
import NumberAppeal from './containers/numberOptions/numberAppeal';
import NumberSuccessPage from './containers/numberOptions/successPage';
import Buy from './containers/buy';
import BuyActivity from './containers/buy/activity';
import Activity from './containers/activity';
import ActivityAddress from './containers/activity/activityAddress';
import ActivitySu from './containers/activitySu';
import ActivityResume from './containers/activityResume';
import FileCheck from './containers/fileCheck';
import SecurityPlan from './containers/securityPlan';
import AiTemperature from './containers/product/temperature';
import AppApply from './containers/apply_app';
import Login from './containers/login';
// import SpringerPlan from './containers/springerPlan';
// import SpringerPlanAgreement from './containers/springerPlan/agreement';
// import SpringerPlanApply from './containers/springerPlan/apply.js';
import InspectionApply from './containers/inspectionApply';

import BugSearch from './containers/bugSearch';
import Websitesec from './containers/product/page_website_sescurity';
import './asset/less/base.less';
import {fetchUserLogin, fetchNavigationList, fetchNavListIndex} from './actions/homeAction';
import ConpinModal from './components/conpin';

function isRouter(extraRouter) {
    let routers = ['forum', 'brand', 'submission', 'productCenter', 'productDetail', '/haoma/search'];

    if (extraRouter && extraRouter.length > 0) {
        routers = [].concat(routers, extraRouter);
    }
    const length = routers.length;
    for (let i = 0; i < length; i++) {
        if (location.pathname.indexOf(routers[i]) !== -1) {
            return true;
        }
    }

    return false;
}

class App extends Component {
    static propTypes = {
        fetchUserLogin: PropTypes.func,
        fetchNavigationList: PropTypes.func,
        fetchNavListIndex: PropTypes.func,
        userLoginstate: PropTypes.object,
        navigationList: PropTypes.object,
        productId: PropTypes.object
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            conMinHeight: 0
        };
    }

    componentDidMount() {
        this.props.fetchUserLogin();
        this.props.fetchNavigationList();
        this.setState({
            conMinHeight: window.innerHeight - this.footer.offsetHeight
        });
    }

    render() {
        const {userLoginstate, navigationList, productId} = this.props;
        return <div>
            {
                !isRouter()
                    ? <NavBar
                        userInfo={userLoginstate}
                        navList={navigationList.itemlist}
                        changeNavIndex={this.props.fetchNavListIndex}
                        productId={productId}
                    />
                    : ''
            }
            <div style={{minHeight: `${this.state.conMinHeight}px`}}>
                <Switch>
                    <Route exact path="/" component={Home}/>
                    <Route path="/home" component={Home}/>
                    <Route exact path="/product/ai/temperature" component={AiTemperature}/>
                    <Route path="/product/:id" component={Product}/>
                    <Route path="/apply/:Iid?" component={Apply}/>
                    <Route path="/apply-plan" component={ApplyPlan}/>
                    <Route path="/apply-succ" component={AppliSucc}/>
                    <Route path="/help" component={Help}/>
                    <Route path="/community/:urlId/:fileType?/:typeid?" component={Community}/>
                    <Route exact path="/forum" component={Forum}/>
                    <Route path="/forum/mark/:tagId?" component={Mark}/>
                    <Route path="/forum/page/:aId?" component={Page}/>
                    <Route path="/forum/search/:keywords?" component={Search}/>
                    <Route path="/about/:type?" component={About}/>
                    <Route path="/brand" component={Brand}/>
                    <Route path="/submission" component={Submission}/>
                    <Route path="/productCenter" component={ProductCenter}/>
                    <Route path="/productDetail/:id" component={ProductDetail}/>
                    <Route path="/haoma/search/" component={NumberSearch}/>
                    <Route path="/haoma/result/:keywords" component={NumberSearchResult}/>
                    <Route path="/haoma/common/:id" component={NumberCommon}/>
                    <Route path="/haoma/guide" component={NumberGuide}/>
                    <Route path="/haoma/report" component={NumberReport}/>
                    <Route path="/haoma/appeal/:type" component={NumberAppeal}/>
                    <Route path="/haoma/success/:path/:type?/:selectType?" component={NumberSuccessPage}/>
                    <Route path="/buy" exact component={Buy}/>
                    <Route path="/activity/buy" exact component={BuyActivity}/>
                    <Route path="/activity/address" exact component={ActivityAddress}/>
                    <Route path="/activity/prize" exact component={Activity}/>
                    <Route path="/activity/su" exact component={ActivitySu}/>
                    <Route path="/activity/resume" exact component={ActivityResume}/>
                    <Route path="/fileCheck/:type/:key" component={FileCheck}/>
                    <Route path="/security/plan" component={SecurityPlan}/>
                    <Route path="/apply-app" component={AppApply}/>
                    <Route path="/apply-inspection" component={InspectionApply}/>
                    <Route path="/login" exact component={Login}/>
                    {/* <Route path="/springer/plan/:channel?" exact component={SpringerPlan}/> */}
                    {/* <Route path="/springer/plan/agreement/:type/:channel?" exact component={SpringerPlanAgreement}/>
                    <Route path="/springer/plan/apply/:channel" exact component={SpringerPlanApply}/> */}
                    <Route path="/bug_search" exact component={BugSearch}/>
                    <Route path="/newsite/websitesec" exact component={Websitesec}/>
                    <Route component={Redirect404}/>
                </Switch>
            </div>
            <div ref={el => this.footer = el}>
                {
                    !isRouter(['/haoma/common', '/haoma/result'])
                        ? <FooterBar/>
                        : null
                }
            </div>
            <ConpinModal/>
        </div>;
    }
}

function mapStateToProps(state) {
    return {
        userLoginstate: state.userLoginstate,
        navigationList: state.navigationList,
        productId: state.productId
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchUserLogin: () => fetchUserLogin(dispatch),
        fetchNavigationList: () => fetchNavigationList(dispatch),
        fetchNavListIndex: index => fetchNavListIndex(dispatch, index)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js